import {updateOrganisation} from '@/libs/api/api'
import {filter, uniq, isEmpty} from 'lodash';
import {message, logout, errorHandler, routeErrorHandler} from '@/libs/helper'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue';
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'

export default {
    name: 'MemberPrivileges',
    mixins: [OrganisationRolesErrorHandlerMixin],
    components: {
        SettingsDropdown
    },
    created () {
        localStorage.setItem('userGroupsColumns', JSON.stringify(this.userGroups))
    },
    data() {
        return {
            collectionCreation: (this.organisationDetails && this.organisationDetails.collection_dossier_creation) || '',
            isCreateTeam: (this.organisationDetails && this.organisationDetails.team_creation_allow_member) || false,
            tableSettings: {
                headings: {
                    group_name: 'Group Name',
                    users: 'Users',
                    date_created: 'Date Created',
                    permissions: 'Permissions',
                    settings: '',
                },
                pagination: { show: false},
                perPage: 30,
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },
            userGroups: [
                'group_name',
                'users',
                'date_created',
                'permissions',
                'settings'
            ],
            userGroupData: [{"group_name": "Group Name 1", "users": "user name", "date_created": '2012-05-30', "permissions": 'True',"_id": 1},{"group_name": "Group Name 1", "users": "user name", "date_created": '2012-05-30', "permissions": 'True',"_id": 2},{"group_name": "Group Name 1", "users": "user name", "date_created": '2012-05-30', "permissions": 'True',"_id": 3}],
            tableColumnsSetting: [
                {key: 'group_name', name: 'Group Name'},
                {key: 'users', name: 'Users'},
                {key: 'date_created', name: 'Date Created'},
                {key: 'permissions', name: 'Permissions'},
                {key: 'settings', name: 'Settings'}
            ],
            filterOption: [],
            isAllMarked: false,
            allMarked: false,
            showBulkUpdate: true,
            isEmpty,
            markedRows: []
        }
    },
    watch: {
        organisationDetails (newValue) {
            this.collectionCreation = (newValue && newValue.collection_dossier_creation) || ''
            this.isCreateTeam = (newValue && newValue.team_creation_allow_member) || false
        },
        userGroups: function (newArray) {
            this.filterOption = Object.assign([], newArray)
        }
    },
    props: {
        organisationDetails: {
            type: Object,
            default: () => {}
        },
        updateFormDataValues: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        /**
         * update collection and dossier creation
         */
        updateCollectionAndDossier () {
            // body for api
            let body = {
                collection_dossier_creation: this.collectionCreation
            }
            // api
            this.updateOrganisationData(body)
        },
        /**
         * 
         */
        updateTeamCreationRules () {
            // body for api
            let body = {
                team_creation_allow_member: this.isCreateTeam
            }
            // api call
            this.updateOrganisationData(body)
        },
        /**
         * api call
         */
        updateOrganisationData (body) {
            // api call
            updateOrganisation(body, this.organisationDetails._id)
            .then((response) => {
                if (response.success) {
                    // update organisation data
                    this.updateFormDataValues({...this.organisationDetails, ...body})
                    // success message
                    message(this, constants.messageType.SUCCESS, 'Updated Successfully')
                }
            }).catch(error => {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                // error handler for permissions
                this.rolesErrorHandler(error)
            })
        },
        /**
         * change create collection
         * @param {*} value 
         */
        changeCreateCollection (value) {
            this.collectionCreation = value
        },
        /**
         * Handle Settings option
        **/
       // eslint-disable-next-line
        handleCommand (command, data) {
            switch (command) {
                case 'DASHBOARD':
                break;
                case 'SETTINGS':
                break;
                case 'ARCHIVE':
                break;
                case 'ADD_TO_URL_REPORTING_GROUP':
                break;
            }
        },
        /**
         * Add and Remove for Table Settings Columns
        **/
        addOrRemoveColumn (isChecked, val) {
            this.filterOption = JSON.parse(localStorage.getItem('userGroupsColumns')) || this.userGroups
            if (isChecked) {
                this.filterOption.push(val.key)
            } else {
                this.filterOption = this.filterOption.filter(item => item !== val.key)
            }
            this.userGroups = filter(this.tableColumnsSetting, (o) => uniq(this.filterOption).includes(o.key)).map((o) => o.key)
            localStorage.setItem('userGroupsColumns', JSON.stringify(this.userGroups))
        },
        toggleAll (event) {
            if (!this.showBulkUpdate) return
            this.markedRows = []
            this.allMarked = event
            this.markedRows = this.allMarked ? this.$refs.table.data.map(row=>row._id) : []  
            if(!isEmpty(this.markedRows)) {
                this.markedRows = this.markedRows.filter((item,index)=>{
                    if(index< this.selected)
                        console.log(this.selected)
                        return item
                })
            }
        },
        toggleSingleItem(id) {
            if (!this.markedRows.includes(id)) {
              this.markedRows.push(id)
           } else {
               const index = this.markedRows.indexOf(id)
               if (index > -1) {
                this.markedRows.splice(index, 1);
               }
           }
        },
        clearBulkSelection() {
            this.markedRows = []
            this.isAllMarked = false
            this.isBulkEdit = false
        }
    }
}